import React from 'react';

export const AlertContext = React.createContext({
    showAlert: 0,
    toggleAlert: () => {},
  });